/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const ArrowRight = props => (
  <svg viewBox="0 0 12 10" width="1em" height="1em" {...props}>
    <path
      d="M.5 6.001h7.984l-2.342 2.42a.522.522 0 000 .715l.684.717a.47.47 0 00.684 0l4.35-4.506a.526.526 0 000-.717L7.538.15a.466.466 0 00-.684 0L6.17.866a.523.523 0 000 .716l2.341 2.419H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5z"
      fill="#5D6164"
      fillRule="evenodd"
    />
  </svg>
);
export default extendIcon(ArrowRight);
